var _style, _linearGradient, _circle, _g, _linearGradient2, _circle2, _g2, _linearGradient3, _circle3, _radialGradient, _circle4, _linearGradient4, _circle5, _linearGradient5, _path, _linearGradient6, _circle6, _radialGradient2, _circle7, _linearGradient7, _use, _linearGradient8, _use2, _use3, _linearGradient9, _use4, _linearGradient0, _use5, _linearGradient1, _use6, _path2, _use7, _use8, _path3, _use9, _use0, _path4, _use1, _use10, _path5, _use11, _use12, _path6, _linearGradient10, _path7, _linearGradient11, _path8, _path9, _use13, _use14, _use15, _path0, _linearGradient12, _use16, _linearGradient13, _path1, _linearGradient14, _path10, _g3, _path11, _g4, _g5, _g6, _linearGradient15, _path12, _linearGradient16, _path13, _linearGradient17, _use17, _linearGradient18, _path14, _linearGradient19, _path15, _linearGradient20, _path16, _linearGradient21, _path17, _linearGradient22, _use18, _linearGradient23, _use19, _linearGradient24, _path18, _linearGradient25, _path19, _linearGradient26, _use20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVipIconRu = function SvgVipIconRu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 558.8 579.6",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4,
    y1: 579.6,
    x2: 279.4,
    y2: 20.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 300.2,
    r: 279.4,
    fill: "url(#A)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Ae"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4,
    y1: 20.8,
    x2: 279.4,
    y2: 579.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.4 21.8c37.6 0 74 7.4 108.4 21.9 33.2 14 62.9 34.1 88.5 59.7s45.6 55.3 59.7 88.5c14.5 34.3 21.9 70.8 21.9 108.4s-7.4 74-21.9 108.4c-14 33.2-34.1 62.9-59.7 88.5s-55.3 45.6-88.5 59.7c-34.3 14.5-70.8 21.9-108.4 21.9s-74-7.4-108.4-21.9c-33.2-14-62.9-34.1-88.5-59.7s-45.6-55.3-59.7-88.5C8.4 374.2 1 337.8 1 300.2s7.4-74 21.9-108.4c14-33.2 34.1-62.9 59.7-88.5s55.3-45.6 88.5-59.7c34.3-14.5 70.7-21.8 108.3-21.8m0-1C125.1 20.8 0 145.9 0 300.2s125.1 279.4 279.4 279.4 279.4-125.1 279.4-279.4S433.7 20.8 279.4 20.8z",
    fill: "url(#B)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4,
    y1: 558.8,
    x2: 279.4,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 279.4,
    fill: "url(#C)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4,
    y1: 0,
    x2: 279.4,
    y2: 558.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fce2ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc9a11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.4 3c37.3 0 73.5 7.3 107.6 21.7 32.9 13.9 62.5 33.9 87.9 59.2 25.4 25.4 45.3 54.9 59.2 87.9 14.4 34.1 21.7 70.3 21.7 107.6s-7.3 73.5-21.7 107.6c-13.9 32.9-33.9 62.5-59.2 87.9-25.4 25.4-54.9 45.3-87.9 59.2-34.1 14.4-70.3 21.7-107.6 21.7s-73.5-7.3-107.6-21.7c-32.9-13.9-62.5-33.9-87.9-59.2C58.5 449.5 38.6 420 24.7 387 10.3 352.9 3 316.7 3 279.4s7.3-73.5 21.7-107.6C38.6 138.9 58.6 109.3 84 84c25.4-25.4 54.9-45.3 87.9-59.2C205.9 10.3 242.1 3 279.4 3m0-3C125.1 0 0 125.1 0 279.4s125.1 279.4 279.4 279.4 279.4-125.1 279.4-279.4S433.7 0 279.4 0z",
    fill: "url(#D)"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4,
    y1: 552.6,
    x2: 279.4,
    y2: 6.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e9e9e"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 273.2,
    fill: "url(#E)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: 279.4,
    cy: 175.4,
    r: 273.2,
    gradientTransform: "matrix(1 0 0 1 0 104)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopOpacity: 0.515
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 273.2,
    fill: "url(#F)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4,
    y1: 526.6,
    x2: 279.4,
    y2: 32.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 247.2,
    fill: "url(#G)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4,
    y1: 32.2,
    x2: 279.4,
    y2: 526.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7b53c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.4 33.7c33.2 0 65.3 6.5 95.6 19.3 29.3 12.4 55.5 30.1 78.1 52.7s40.3 48.8 52.7 78.1c12.8 30.3 19.3 62.5 19.3 95.6s-6.5 65.3-19.3 95.6c-12.4 29.3-30.1 55.5-52.7 78.1s-48.8 40.3-78.1 52.7c-30.3 12.8-62.5 19.3-95.6 19.3s-65.3-6.5-95.6-19.3c-29.3-12.4-55.5-30.1-78.1-52.7S65.4 404.3 53 375c-12.8-30.3-19.3-62.5-19.3-95.6s6.5-65.3 19.3-95.6c12.4-29.3 30.1-55.5 52.7-78.1s48.8-40.3 78.1-52.7c30.3-12.8 62.4-19.3 95.6-19.3m0-1.5c-136.5 0-247.2 110.7-247.2 247.2s110.7 247.2 247.2 247.2 247.2-110.7 247.2-247.2S415.9 32.2 279.4 32.2z",
    fill: "url(#H)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4,
    y1: 505.8,
    x2: 279.4,
    y2: 53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c7c7c"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 226.4,
    fill: "url(#I)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "J",
    cx: 279.4,
    cy: 175.4,
    r: 226.4,
    gradientTransform: "matrix(1 0 0 1 0 104)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopOpacity: 0.515
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 226.4,
    fill: "url(#J)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 225.4,
    y1: 128.3,
    x2: 225.4,
    y2: 84.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    fill: "url(#K)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 225.45,
    y1: 128.3,
    x2: 225.45,
    y2: 84.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    fill: "url(#L)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    x: 64.4,
    fill: "url(#K)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 289.85,
    y1: 128.3,
    x2: 289.85,
    y2: 84.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    fill: "url(#M)"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 352.1,
    y1: 128.3,
    x2: 352.1,
    y2: 84.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z",
    fill: "url(#N)"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 352.15,
    y1: 128.3,
    x2: 352.15,
    y2: 84.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AA",
    fill: "url(#O)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1 88.8l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    className: "Ad Ae"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    fill: "url(#K)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    fill: "url(#L)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 88.8l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    className: "Ad Ae"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    x: 64.4,
    fill: "url(#K)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    fill: "url(#M)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M351.8 88.8l5.5 17.1h16.6l-12.4 10.4 3.8 16.1-13.5-7.4-13.4 7.4 4.4-16.1-12.5-10.4h16.6z",
    className: "Ad Ae"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z",
    fill: "url(#N)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AA",
    fill: "url(#O)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1 429.5l5.5 17.1h16.6L234.7 457l3.9 16.1-13.5-7.4-13.5 7.4L216 457l-12.4-10.4h16.6z",
    className: "Ad Ae"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    y: 340.7,
    fill: "url(#K)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    y: 340.7,
    fill: "url(#L)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 429.5l5.5 17.1h16.6L299.1 457l3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    className: "Ad Ae"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 289.8,
    y1: 469,
    x2: 289.8,
    y2: 425.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 425.4l5.5 17.1h16.6l-12.5 10.4L303 469l-13.5-7.5L276 469l4.4-16.1-12.4-10.4h16.6z",
    fill: "url(#P)"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 289.8,
    y1: 469,
    x2: 289.8,
    y2: 425.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 426.4l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1H268l12.5 10.4L276 469l13.5-7.5L303 469l-3.9-16.1 12.5-10.4H295l-5.5-17.1z",
    fill: "url(#Q)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M351.8 429.5l5.5 17.1h16.6L361.5 457l3.8 16.1-13.5-7.4-13.4 7.4 4.4-16.1-12.5-10.4h16.6z",
    className: "Ad Ae"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z",
    y: 340.7,
    fill: "url(#N)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AA",
    y: 340.7,
    fill: "url(#O)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M276.8 370.8V192.5h34.3v178.3h-34.3zm69.1 0v-176c11.2-2.1 26.5-3.8 46.2-3.8 22.5 0 39.4 4.4 50.8 14.1 10.7 9 17.1 23.4 17.1 39.8 0 48.9-40.8 59.8-67.4 59.8-4.9 0-9-.2-12.5-1v66.8l-34.2.3zm34-93.6c3.3.7 6.9 1 12 1 21.4 0 33.9-12 33.9-31.3 0-19.1-12-29-31.1-29-6.9 0-11.8.7-14.8 1.3v58z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 185.95,
    y1: 370.8,
    x2: 185.95,
    y2: 192.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    y: -3.9,
    fill: "url(#R)"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 293.95,
    y1: 366.9,
    x2: 293.95,
    y2: 188.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M276.8 366.9V188.6h34.3v178.3h-34.3z",
    fill: "url(#S)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 402.95,
    y1: 366.9,
    x2: 402.95,
    y2: 187.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9 366.9v-176c11.2-2.1 26.5-3.8 46.2-3.8 22.5 0 39.4 4.4 50.8 14.1 10.7 9 17.1 23.4 17.1 39.8 0 48.9-40.8 59.8-67.4 59.8-4.9 0-9-.2-12.5-1v66.8l-34.2.3zm34-93.7c3.3.7 6.9 1 12 1 21.4 0 33.9-12 33.9-31.3 0-19.1-12-29-31.1-29-6.9 0-11.8.7-14.8 1.3v58z",
    fill: "url(#T)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 185.95,
    y1: 366.9,
    x2: 185.95,
    y2: 188.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.4 189.4l-53.8 176.7h-38l-51.3-176.7h36l20 78.2c4.9 19.5 10.5 41.7 14.3 63.9l.1.7h2.1l.1-.7c3.5-18.5 8.2-38.9 14.8-63.9l20.5-78.2h35.2m1.1-.8h-36.9L201 267.4c-5.6 20.9-10.9 42.6-14.8 64h-.8c-3.8-21.6-9-42.9-14.3-64l-20.2-78.8h-37.5l51.7 178.3h39.2l54.2-178.3z",
    fill: "url(#U)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 293.95,
    y1: 366.9,
    x2: 293.95,
    y2: 188.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.4 189.4v176.7h-32.8V189.4h32.8m.7-.8h-34.3v178.3h34.3V188.6z",
    fill: "url(#V)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 402.9,
    y1: 367,
    x2: 402.9,
    y2: 187.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392.1 187.9c22.9 0 39.4 4.5 50.3 14 10.8 9.1 16.8 23.4 16.8 39.3 0 21.5-7.9 37.4-23.4 47.6-15.2 9.9-33.7 11.4-43.3 11.4-5.3 0-9.2-.3-12.4-.9l-1-.2v67h-32.5V191.5c12.8-2.3 28.5-3.6 45.5-3.6m0 87c21.4 0 34.6-12.3 34.6-32 0-19-11.6-29.7-31.8-29.7-7.3 0-12.2.8-15 1.4l-.6.1v59.1l.6.1c3 .7 6.6 1 12.2 1m0-87.7c-19.7 0-35 1.6-46.2 3.8v176H380v-66.8c3.5.7 7.7 1 12.5 1 26.7 0 67.4-10.9 67.4-59.8 0-16.5-6.4-30.8-17.1-39.8-11.4-10-28.3-14.4-50.7-14.4zm0 86.9c-5.1 0-8.9-.2-12-1v-57.9c3-.7 7.9-1.3 14.8-1.3 19.1 0 31.1 10 31.1 29-.2 19.1-12.7 31.2-33.9 31.2z",
    fill: "url(#W)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M437.7 113.3l-11.9-17.7 16.6 15.1c3.2 2.9 7.9 3.2 11.5.8l28-18.9-22.9 23.8c-3 3.1-3.5 7.8-1.3 11.5l11.2 17.7-13.1-10.3c-5.6-4.8-13.7-5.5-20-1.5l-19 11.9 19.7-19.7c3.4-3.5 3.9-8.8 1.2-12.7z",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "Ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.7 141.7l-2 5c-1.9-1.4-4.8-2.1-8.8-2.1-3.9 0-7 1.7-9.2 5s-3.3 7.5-3.3 12.4c0 4.6 1.1 8.5 3.3 11.7s5.3 4.7 9.2 4.7c4 0 7.1-1.4 9.2-4.2l3.3 4.5c-3.4 3.4-7.8 5-13.2 5-5.7 0-10.1-2-13.3-6.1s-4.8-9.4-4.8-15.9c0-6.3 1.7-11.5 5.1-15.9s7.8-6.5 13.4-6.5c4.7 0 8.4.8 11.1 2.4zm24.7 3.7V183h-5.9v-37.6h-13.6v-5.3h33.8v5.3h-14.3z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 183v-20.8h-18.7V183h-5.9v-42.9h5.9v17.1H325v-17.1h5.9V183H325zm20.5-26.6l6.1-.3c5 0 8.9 1.1 11.7 3.4s4.1 5.6 4.1 9.8-1.4 7.6-4.2 10-6.5 3.6-11 3.6h-12.5V140h5.9v16.4zm0 21.6c1.6.2 3.4.3 5.3.3 6.9 0 10.3-3 10.3-9.1 0-2.7-.9-4.8-2.6-6.2s-4.2-2.1-7.4-2.1c-2 0-3.9.1-5.7.3V178z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2 426.5h-5.9v-30.8l-24.1 31.4h-1.6v-43.5h5.9v30.8l24.1-31.4h1.6v43.5zm33.8-37.6h-19.1v37.6H194v-42.9h25v5.3z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AD"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7 426.7c-.3.1-1 .1-2.2.1-2.4 0-4.2-.6-5.4-1.9-1.1-1.3-2-3.4-2.5-6.5-.7-4.2-2.1-7.3-4.3-9.2s-5.2-2.9-9.2-2.9h-.1v20.2h-5.9v-42.9h5.9v17.8h.6c3.7 0 6.6-.8 8.8-2.5s3.6-4.1 4.1-7.4c.5-2.9 1.3-4.9 2.4-6.2s2.8-1.9 5.2-1.9c.8 0 1.4 0 2.1.1v5c-.1 0-.5-.1-1.2-.1s-1.3.2-1.7.7-.8 1.6-1.1 3.3c-.5 2.8-1.7 5.1-3.5 7.1s-4 3.4-6.7 4.1c5.9 2.1 9.5 6.4 10.8 13.2.4 2 .8 3.2 1.2 3.8s1 .8 1.7.8c.4 0 .8 0 1.3-.1v5.4zm5.1-22c0-6.2 1.6-11.4 4.7-15.6s7.3-6.3 12.6-6.3c6 0 10.6 1.9 13.7 5.8 3.2 3.9 4.7 9.2 4.7 16 0 7-1.6 12.5-4.8 16.5s-7.7 6-13.7 6c-5.5 0-9.7-2.1-12.7-6.3-3-4.1-4.5-9.5-4.5-16.1zm6.2 0c0 5 1 9.1 2.9 12.3 1.9 3.3 4.7 4.9 8.2 4.9 4 0 7.1-1.5 9.2-4.5s3.1-7.3 3.1-12.8c0-11.1-4.1-16.6-12.3-16.6-3.6 0-6.3 1.5-8.2 4.4-2 2.9-2.9 7-2.9 12.3z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 206,
    y1: 179.7,
    x2: 206,
    y2: 133.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.7 134.3c4.6 0 8.2.8 11 2.3l-2 5c-1.9-1.4-4.8-2.1-8.8-2.1-3.9 0-7 1.7-9.2 5-2.2 3.4-3.3 7.5-3.3 12.4 0 4.6 1.1 8.6 3.3 11.7 2.2 3.2 5.3 4.7 9.2 4.7 4 0 7.1-1.4 9.2-4.2l3.3 4.5c-3.4 3.4-7.8 5-13.2 5-5.7 0-10.1-2-13.3-6.1s-4.8-9.4-4.8-15.9c0-6.3 1.7-11.5 5.1-15.9s8-6.4 13.5-6.4m0-1c-5.9 0-10.7 2.3-14.2 6.9-3.5 4.5-5.3 10-5.3 16.5 0 6.7 1.7 12.3 5 16.5 3.4 4.3 8.1 6.5 14.1 6.5 5.6 0 10.3-1.8 13.9-5.3l.6-.6-.5-.7-3.3-4.5-.8-1.1-.8 1.1c-2 2.6-4.7 3.9-8.4 3.9-3.6 0-6.3-1.4-8.4-4.3-2.1-3-3.2-6.7-3.2-11.1 0-4.7 1.1-8.7 3.1-11.8s4.7-4.6 8.3-4.6c3.8 0 6.5.6 8.2 1.9l1.1.8.5-1.2 2-5 .3-.8-.7-.4c-2.9-1.8-6.7-2.7-11.5-2.7z",
    fill: "url(#X)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: 241.8,
    y1: 179,
    x2: 241.8,
    y2: 134.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.7 135.1v5.3h-14.3V178h-5.9v-37.6h-13.6v-5.3h33.8m1-1h-35.8v7.3h13.6V179h7.9v-37.6h14.3v-7.3z",
    fill: "url(#Y)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientUnits: "userSpaceOnUse",
    x1: 278.05,
    y1: 179,
    x2: 278.05,
    y2: 133.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.6 134.5l16.2 43.5h-6.5l-2.9-9.1h-16l-3.2 9.1h-6.5l17.4-43.5h1.5m-7.7 30.1h12.7l-6-18.9-6.7 18.9m8.4-31.1h-3l-.3.6-17.4 43.5-.5 1.4h8.7l.2-.7 3-8.4h14.5l2.7 8.4.2.7h8.6l-.5-1.3-16.2-43.5v-.7zm-7 30.1l5.2-14.8 4.7 14.8h-9.9z",
    fill: "url(#Z)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 315.65,
    y1: 179,
    x2: 315.65,
    y2: 134.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.9 135.1V178H325v-20.8h-18.7V178h-5.9v-42.9h5.9v17.1H325v-17.1h5.9m1-1H324v17.1h-16.7v-17.1h-7.9V179h7.9v-20.8H324V179h7.9v-44.9z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 353.5,
    y1: 179,
    x2: 353.5,
    y2: 134.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 135.1v16.3l6.1-.3c5 0 8.9 1.1 11.7 3.4s4.1 5.6 4.1 9.8-1.4 7.6-4.2 10-6.5 3.6-11 3.6h-12.5V135h5.8m5.4 38.3c6.9 0 10.3-3 10.3-9.1 0-2.7-.9-4.8-2.6-6.2s-4.2-2.1-7.4-2.1c-2 0-3.9.1-5.7.3V173c1.7.2 3.4.3 5.4.3m-4.4-39.2h-7.9V179h13.5c4.8 0 8.7-1.3 11.7-3.9s4.6-6.2 4.6-10.7c0-4.6-1.5-8.1-4.5-10.6-2.9-2.4-7.1-3.7-12.3-3.7-1.6 0-3.3.1-5.1.2v-16.2zm0 23c1.5-.1 3.1-.2 4.7-.2 3 0 5.2.6 6.8 1.9 1.5 1.2 2.2 3 2.2 5.4 0 5.5-3 8.1-9.3 8.1-1.5 0-3-.1-4.3-.2v-15h-.1z",
    fill: "url(#b)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 165.4,
    y1: 423.1,
    x2: 165.4,
    y2: 377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.2 378v43.5h-5.9v-30.8l-24.1 31.4h-1.6v-43.5h5.9v30.8l24.1-31.4h1.6m1-1h-3.1l-.3.4-22.3 29v-28.8h-7.9v45.5h3.1l.3-.4 22.3-29v28.8h7.9V377z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 202.5,
    y1: 422.5,
    x2: 202.5,
    y2: 377.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215 378.6v5.3h-19.1v37.6H190v-42.9h25m1-1h-27v44.9h7.9v-37.6H216v-7.3z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 234.6,
    y1: 422.5,
    x2: 234.6,
    y2: 377.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.2 378.3c12.5 0 18.7 4.2 18.7 12.5 0 9.6-5.5 14.5-16.6 14.5-.9 0-2.4-.1-4.3-.2v16.5h-5.9v-42.9c3.8-.3 6.5-.4 8.1-.4M231 400c7.3 0 10.9-2.9 10.9-8.6 0-5.2-3.9-7.9-11.6-7.9-1 0-2.1.1-3.2.3v15.8l3.9.4m-1.8-22.7c-1.7 0-4.4.1-8.1.3l-.9.1v44.8h7.9v-16.4c1.5.1 2.6.2 3.3.2 11.6 0 17.6-5.2 17.6-15.5 0-9-6.7-13.5-19.8-13.5zm-1.1 7.4c.8-.1 1.5-.2 2.2-.2 10.6 0 10.6 5.2 10.6 6.9 0 3.3-1 7.6-9.9 7.6l-2.9-.2v-14.1z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 270.5,
    y1: 423.2,
    x2: 270.5,
    y2: 376.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.9 377.8c6 0 10.6 1.9 13.7 5.8 3.2 3.9 4.7 9.2 4.7 16 0 7-1.6 12.5-4.8 16.5s-7.7 6-13.7 6c-5.5 0-9.7-2.1-12.7-6.3s-4.5-9.6-4.5-16.2c0-6.2 1.6-11.4 4.7-15.6 3.1-4.1 7.3-6.2 12.6-6.2m0 39.1c4 0 7.1-1.5 9.2-4.5s3.1-7.3 3.1-12.8c0-11.1-4.1-16.6-12.3-16.6-3.6 0-6.3 1.5-8.2 4.4s-2.9 7-2.9 12.2c0 5 1 9.1 2.9 12.3 1.9 3.4 4.7 5 8.2 5m0-40.1c-5.6 0-10.1 2.2-13.4 6.7-3.2 4.3-4.9 9.8-4.9 16.2 0 6.8 1.6 12.4 4.7 16.8 3.2 4.5 7.8 6.7 13.6 6.7 6.2 0 11.1-2.2 14.5-6.4 3.3-4.2 5-10 5-17.1 0-7-1.7-12.6-5-16.7s-8.2-6.2-14.5-6.2zm0 39.1c-3.2 0-5.6-1.4-7.4-4.4-1.8-3.1-2.7-7.1-2.7-11.8 0-5 .9-9 2.7-11.7 1.7-2.6 4.2-3.9 7.4-3.9 7.6 0 11.3 5.1 11.3 15.6 0 5.3-1 9.4-3 12.2-1.8 2.7-4.6 4-8.3 4z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 309.75,
    y1: 422.793,
    x2: 309.75,
    y2: 377.346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322 378.3l2.1.1v5c-.1 0-.5-.1-1.2-.1s-1.3.2-1.7.7-.8 1.6-1.1 3.3c-.5 2.8-1.7 5.1-3.5 7.1s-4 3.4-6.7 4.1c5.9 2.1 9.5 6.4 10.8 13.2.4 2 .8 3.2 1.2 3.8s1 .8 1.7.8c.4 0 .8 0 1.3-.1v5.2c-.3.1-1 .1-2.2.1-2.4 0-4.2-.6-5.4-1.9s-2-3.4-2.5-6.5c-.7-4.2-2.1-7.3-4.3-9.2s-5.2-2.9-9.2-2.9h-.3v20.2h-5.9v-42.9h5.9v17.8h.6c3.7 0 6.6-.8 8.8-2.5s3.6-4.1 4.1-7.4c.5-2.9 1.3-4.9 2.4-6.2s2.8-1.7 5.1-1.7m0-1c-2.6 0-4.6.8-5.9 2.2-1.2 1.4-2.1 3.6-2.6 6.7-.5 3-1.7 5.2-3.8 6.7-1.9 1.5-4.5 2.3-7.8 2.3v-17.7H294v44.9h7.9v-20.1c3.3.1 5.9 1 7.7 2.6 2 1.8 3.3 4.7 4 8.6.6 3.3 1.5 5.6 2.7 7 1.3 1.5 3.4 2.2 6.1 2.2 1.6 0 2.1-.1 2.4-.2l.7-.2v-7.2l-1.2.2c-.4.1-.7.1-1.1.1s-.6-.1-.9-.4c-.2-.2-.6-.9-1-3.3-1.2-6.1-4.2-10.5-9-12.9 1.8-.9 3.4-2 4.8-3.5 1.9-2.1 3.1-4.7 3.7-7.6.4-2.1.8-2.7.9-2.9s.4-.4.9-.4h1l1.3.4v-7.2l-.8-.1a10.61 10.61 0 0 0-2.1-.2z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 347.7,
    y1: 423.2,
    x2: 347.7,
    y2: 376.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.1 377.8c6 0 10.6 1.9 13.7 5.8s4.7 9.2 4.7 16c0 7-1.6 12.5-4.8 16.5s-7.7 6-13.7 6c-5.5 0-9.7-2.1-12.7-6.3s-4.5-9.6-4.5-16.2c0-6.2 1.6-11.4 4.7-15.6 3.1-4.1 7.3-6.2 12.6-6.2m0 39.1c4 0 7.1-1.5 9.2-4.5s3.1-7.3 3.1-12.8c0-11.1-4.1-16.6-12.3-16.6-3.6 0-6.3 1.5-8.2 4.4s-2.9 7-2.9 12.2c0 5 1 9.1 2.9 12.3 1.9 3.4 4.6 5 8.2 5m0-40.1c-5.6 0-10.1 2.2-13.4 6.7-3.2 4.3-4.9 9.8-4.9 16.2 0 6.8 1.6 12.4 4.7 16.8 3.2 4.5 7.8 6.7 13.6 6.7 6.3 0 11.1-2.2 14.5-6.4 3.3-4.2 5-10 5-17.1 0-7-1.7-12.6-5-16.7-3.4-4.1-8.3-6.2-14.5-6.2zm0 39.1c-3.2 0-5.6-1.4-7.4-4.4-1.8-3.1-2.7-7.1-2.7-11.8 0-5 .9-9 2.7-11.7 1.7-2.6 4.2-3.9 7.4-3.9 7.6 0 11.3 5.1 11.3 15.6 0 5.3-1 9.4-3 12.2-1.9 2.7-4.6 4-8.3 4z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 390.2,
    y1: 423.1,
    x2: 390.2,
    y2: 377.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.6 378.6l8.4 42.9h-5.6l-5.2-27.7-9.5 28.3h-1.5l-9.3-28.3-5 27.7h-5.6l8.3-42.9h2.6l10 31.3 9.9-31.3h2.5m.8-1h-4l-.2.7-9 28.3-9-28.3-.2-.7h-4.1l-.2.8-8.3 42.9-.2 1.2h7.6l.1-.8 4.3-23.9 8.1 24.6.2.7h2.9l.2-.7 8.3-24.6 4.5 23.9.2.8h7.6l-.2-1.2-8.4-42.9-.2-.8z",
    fill: "url(#i)"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 205.75,
    y1: 178.7,
    x2: 205.75,
    y2: 134.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.7 136.7l-2 5c-1.9-1.4-4.8-2.1-8.8-2.1-3.9 0-7 1.7-9.2 5-2.2 3.4-3.3 7.5-3.3 12.4 0 4.6 1.1 8.6 3.3 11.7 2.2 3.2 5.3 4.7 9.2 4.7 4 0 7.1-1.4 9.2-4.2l3.3 4.5c-3.4 3.4-7.8 5-13.2 5-5.7 0-10.1-2-13.3-6.1s-4.8-9.4-4.8-15.9c0-6.3 1.7-11.5 5.1-15.9s7.8-6.5 13.4-6.5c4.7 0 8.4.8 11.1 2.4z",
    fill: "url(#j)"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 241.8,
    y1: 178,
    x2: 241.8,
    y2: 135.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M244.4,140.4V178h-5.9v-37.6h-13.6v-5.3h33.8v5.3H244.4z",
    fill: "url(#k)"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 278.2,
    y1: 183,
    x2: 278.2,
    y2: 139.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    y: -5,
    fill: "url(#l)"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 315.65,
    y1: 178,
    x2: 315.65,
    y2: 135.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M325,178v-20.8h-18.7V178h-5.9v-42.9h5.9v17.1H325v-17.1h5.9V178H325z",
    fill: "url(#m)"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 353.55,
    y1: 178,
    x2: 353.55,
    y2: 135.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M345.5 151.4l6.1-.3c5 0 8.9 1.1 11.7 3.4s4.1 5.6 4.1 9.8-1.4 7.6-4.2 10-6.5 3.6-11 3.6h-12.5V135h5.9v16.4h-.1zm0 21.6c1.6.2 3.4.3 5.3.3 6.9 0 10.3-3 10.3-9.1 0-2.7-.9-4.8-2.6-6.2s-4.2-2.1-7.4-2.1c-2 0-3.9.1-5.7.3V173h.1z",
    fill: "url(#n)"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 165.4,
    y1: 422.1,
    x2: 165.4,
    y2: 378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.2 421.5h-5.9v-30.8l-24.1 31.4h-1.6v-43.5h5.9v30.8l24.1-31.4h1.6v43.5z",
    fill: "url(#o)"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 202.5,
    y1: 421.5,
    x2: 202.5,
    y2: 378.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M215 383.9h-19.1v37.6H190v-42.9h25v5.3z",
    fill: "url(#p)"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 238.55,
    y1: 426.5,
    x2: 238.55,
    y2: 383.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AD",
    x: -4,
    y: -5,
    fill: "url(#q)"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 274.45,
    y1: 427.232,
    x2: 274.45,
    y2: 382.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AE",
    x: -4,
    y: -5,
    fill: "url(#r)"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 310.05,
    y1: 421.8,
    x2: 310.05,
    y2: 378.353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M324.7 421.7c-.3.1-1 .1-2.2.1-2.4 0-4.2-.6-5.4-1.9s-2-3.4-2.5-6.5c-.7-4.2-2.1-7.3-4.3-9.2s-5.2-2.9-9.2-2.9h-.1v20.2h-5.9v-42.9h5.9v17.8h.6c3.7 0 6.6-.8 8.8-2.5s3.6-4.1 4.1-7.4c.5-2.9 1.3-4.9 2.4-6.2s2.8-1.9 5.2-1.9c.8 0 1.4 0 2.1.1v5c-.1 0-.5-.1-1.2-.1s-1.3.2-1.7.7-.8 1.6-1.1 3.3c-.5 2.8-1.7 5.1-3.5 7.1s-4 3.4-6.7 4.1c5.9 2.1 9.5 6.4 10.8 13.2.4 2 .8 3.2 1.2 3.8s1 .8 1.7.8c.4 0 .8 0 1.3-.1v5.4h-.3z",
    fill: "url(#s)"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 347.65,
    y1: 422.232,
    x2: 347.65,
    y2: 377.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M329.8 399.7c0-6.2 1.6-11.4 4.7-15.6s7.3-6.3 12.6-6.3c6 0 10.6 1.9 13.7 5.8s4.7 9.2 4.7 16c0 7-1.6 12.5-4.8 16.5s-7.7 6-13.7 6c-5.5 0-9.7-2.1-12.7-6.3s-4.5-9.5-4.5-16.1zm6.2 0c0 5 1 9.1 2.9 12.3 1.9 3.3 4.7 4.9 8.2 4.9 4 0 7.1-1.5 9.2-4.5s3.1-7.3 3.1-12.8c0-11.1-4.1-16.6-12.3-16.6-3.6 0-6.3 1.5-8.2 4.4s-2.9 7-2.9 12.3z",
    fill: "url(#t)"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 394.15,
    y1: 427.1,
    x2: 394.15,
    y2: 383.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AF",
    x: -4,
    y: -5,
    fill: "url(#u)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M225.1 84.7l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.5-13.5 7.5 4.4-16.1-12.4-10.4h16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M225.1 85.7l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1h-16.6l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4h-16.6l-5.6-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M289.5 85.7l5.2 16.2.1.2h16L299 112l-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1H268l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4H295l-5.5-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "M351.8 84.7l5.5 17.1h16.6l-12.4 10.4 3.8 16.1-13.5-7.5-13.4 7.5 4.4-16.1-12.5-10.4h16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AA",
    d: "M351.9 85.7l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m-.1-1l-4.9 17.1h-16.6l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4h-16.6l-5.6-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AB",
    d: "M221.7 192.5h36.9l-54.3 178.3h-39.2l-51.8-178.3h37.5l20.2 78.8c5.3 21.1 10.7 42.4 14.3 64h.7c3.9-21.4 9.2-43.1 14.8-64l20.9-78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AC",
    d: "M289.2 183l-2.9-9.1h-16l-3.2 9.1h-6.5l17.4-43.5h1.6l16.2 43.5h-6.6zm-10.6-32.3l-6.7 18.9h12.7l-6-18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AD",
    d: "M231.1 410v16.5h-5.9v-42.9l8-.3c12.5 0 18.7 4.2 18.7 12.5 0 9.6-5.5 14.5-16.6 14.5-.8-.1-2.3-.1-4.2-.3zm0-21.1v15.8l3.9.3c7.3 0 10.9-2.9 10.9-8.6 0-5.2-3.9-7.9-11.6-7.9-1.1.1-2.1.2-3.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AE",
    d: "M256.6 404.7c0-6.2 1.6-11.4 4.7-15.6s7.3-6.3 12.6-6.3c6 0 10.6 1.9 13.7 5.8 3.2 3.9 4.7 9.2 4.7 16 0 7-1.6 12.5-4.8 16.5s-7.7 6-13.7 6c-5.5 0-9.7-2.1-12.7-6.3-2.9-4.1-4.5-9.5-4.5-16.1zm6.2 0c0 5 1 9.1 2.9 12.3 1.9 3.3 4.7 4.9 8.2 4.9 4 0 7.1-1.5 9.2-4.5s3.1-7.3 3.1-12.8c0-11.1-4.1-16.6-12.3-16.6-3.6 0-6.3 1.5-8.2 4.4s-2.9 7-2.9 12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AF",
    d: "M409.4 426.5l-5.2-27.7-9.5 28.3h-1.5l-9.3-28.3-5 27.7h-5.6l8.3-42.9h2.6l10 31.3 9.9-31.3h2.5l8.4 42.9h-5.6z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVipIconRu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vip_icon_ru.7440bb4369d546f750d928df345eb8da.svg";